<script setup lang="ts">
  import MenuKebab2Icon from '@/shared/assets/icons/MenuKebab2Icon.svg';
  import { IconImage } from '@/shared/ui';

  interface Props {
    isVisible: boolean;
    isSelected: boolean;
    tooltipContent?: string;
    cursor?: 'move' | 'pointer';
    draggable?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    tooltipContent: 'Selecionar/mover tabela',
    cursor: 'move',
    draggable: true,
  });

  const emit = defineEmits<(e: 'select-all', event: MouseEvent) => void>();
</script>

<template>
  <button
    v-tippy="{
      content: props.tooltipContent,
      placement: 'top',
      theme: 'custom',
      trigger: 'mouseenter',
      hideOnClick: true,
    }"
    type="button"
    class="table-drag-button absolute top-0 -left-9 z-20 flex h-[25px] w-[22px] items-center justify-center rounded-lg border p-0 text-[var(--color-gray-07)] transition-[opacity,background-color,border-color] duration-150 ease-[ease] hover:border-light-gray-xx hover:bg-gray-12 hover:opacity-100 active:bg-gray-02 group-hover:opacity-100 group-[.is-selected]:opacity-100"
    :class="[
      {
        'drag-handle': props.draggable,
        'is-visible': isVisible,
        'is-selected': isSelected,
      },
      `cursor-${props.cursor}`,
      isSelected
        ? 'border-[#c0c0c0] bg-[rgba(227,227,227,0.5)] opacity-100'
        : isVisible
          ? 'border-gray-02 bg-[var(--color-white-01)] opacity-100'
          : 'border-gray-02 bg-[var(--color-white-01)] opacity-0',
    ]"
    :aria-label="props.tooltipContent"
    @click.stop="emit('select-all', $event)"
  >
    <IconImage
      :src="MenuKebab2Icon"
      :alt="props.tooltipContent"
      class="shrink-0"
    />
  </button>
</template>
